<div class="relative">
  <!-- Floating label (optional) -->
  <label
    *ngIf="floatingLabel"
    class="neptune-floating-label-multi-select-input floating-label"
  >
    {{ label }}
  </label>

  <details
    #detailsElementRef
    class="group peer rounded border-solid border-1 border-black bg-white px-3 py-3 transition-colors duration-200 open:border-blue focus-within:border-blue"
  >
    <summary
      class="flex items-center justify-between cursor-pointer list-none outline-none"
      (click)="onSummaryClick($event)"
    >
      <span class="placeholder-value text-gray-400" *ngIf="!hasValue">
        {{ placeholder }}
      </span>

      <span class="text-gray-900 truncate" *ngIf="hasValue">
        {{ selectedSummary }}
      </span>

      <span
        class="ml-2 text-gray-500 transition-transform duration-200 group-open:rotate-180"
      >
        <img
          src="/assets/shared-icons/neptune-icon-black-chevron-down.svg"
          alt="expand-icon"
          class="flex w-5 h-5 self-center"
        />
      </span>
    </summary>

    <div
      role="listbox"
      [attr.aria-label]="ariaLabel"
      class="absolute left-0 right-0 z-50 max-h-48 overflow-y-auto rounded border border-gray-300 bg-white shadow-lg p-2"
      [ngClass]="{
        'top-[calc(100%+4px)]': dropdownOpenDirection === 'down',
        'bottom-[calc(100%+4px)]': dropdownOpenDirection === 'up',
      }"
    >
      <ng-container *ngIf="options.length > 0; else noOptions">
        <label
          *ngFor="let option of options"
          class="flex items-center gap-2 px-2 py-1.5 rounded cursor-pointer hover:bg-light-blue"
        >
          <input
            type="checkbox"
            class="accent-blue"
            [checked]="isSelected(option)"
            (change)="toggleOption(option, $any($event.target).checked)"
          />

          <span class="text-sm text-gray-900">
            {{ displayFn(option) }}
          </span>
        </label>
      </ng-container>
      <ng-template #noOptions>
        <div class="flex items-center px-2 py-1.5 text-sm rounded text-gray-900 text-center">
          <span class="text-sm w-full max-w-full text-center break-words">{{ noOptionsMessage }}</span>
        </div>
      </ng-template>
    </div>
  </details>
</div>
